/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { JunctionBoxFamilyInformation } from './junction-box-family-information.component';
import { CommonModule } from '@angular/common';
import { SysquePropertiesListModule } from '../../../../../../../shared/ui/src/lib/components/sysque-properties-list';
import { SysqueNumberBoxOptionsLineModule } from '../../../../../../../shared/ui/src/lib/components/sysque-number-box-options-line';
import { SysqueDropdownConnectorsModule } from '../../../../../../../shared/ui/src/lib/components/sysque-dropdown-connectors';
import { SysqueToggleButtonModule } from '../../../../../../../shared/ui/src/lib/components/sysque-switch-button';
import { SysqueTextBoxDescriptionModule } from '../../../../../../../shared/ui/src/lib/components/sysque-text-area-description';
import { DxButtonModule } from 'devextreme-angular';
import { RouterModule, Routes } from '@angular/router';
import { AlertModule } from '../../../../../../../shared/ui/src/lib/components/alert';

const routes: Routes = [
  { path: 'dialog/junction-box-family-information-dialog', component: JunctionBoxFamilyInformation },
];

@NgModule({
  declarations: [JunctionBoxFamilyInformation],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SysquePropertiesListModule,
    SysqueNumberBoxOptionsLineModule,
    SysqueTextBoxDescriptionModule,
    SysqueToggleButtonModule,
    SysqueDropdownConnectorsModule,
    AlertModule,
    DxButtonModule
  ],
  exports: [JunctionBoxFamilyInformation],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JunctionBoxFamilyInformationModule {}
